// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const EditLiftPayment = () => {

//   const location = useLocation();
//   const navigate = useNavigate();

//   const { selectedItem } = location.state;

//   const [paidAmt, setPaidAmt] = useState(
//     selectedItem.li_pay_paid_amt
//   );

//   const [paymentMode, setPaymentMode] = useState(
//     selectedItem.li_payment_mode
//   );

//   const [remarks, setRemarks] = useState(
//     selectedItem.li_pay_remark
//   );

//   async function updatePayment() {

//     const response = await fetch(
//       "https://liftapp.infysky.in/liftapp_api/api/update_lift_payment",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           li_pay_id: selectedItem.li_pay_id,
//           paidAmt,
//           paymentMode,
//           remarks,
//         }),
//       }
//     );

//     const data = await response.json();

//     alert(data.message);

//     navigate("/app/lift_paid_data");
//   }

//   return (
//     <div className="container mt-5">

//       <h3>Edit Lift Payment</h3>

//       <div className="mb-3">
//         <label>Customer Name</label>
//         <input
//           type="text"
//           className="form-control"
//           value={selectedItem.li_pay_cu_name}
//           disabled
//         />
//       </div>

//       <div className="mb-3">
//         <label>Paid Amount</label>
//         <input
//           type="number"
//           className="form-control"
//           value={paidAmt}
//           onChange={(e) => setPaidAmt(e.target.value)}
//         />
//       </div>

//       <div className="mb-3">
//         <label>Payment Mode</label>
//         <input
//           type="text"
//           className="form-control"
//           value={paymentMode}
//           onChange={(e) => setPaymentMode(e.target.value)}
//         />
//       </div>

//       <div className="mb-3">
//         <label>Remarks</label>
//         <textarea
//           className="form-control"
//           value={remarks}
//           onChange={(e) => setRemarks(e.target.value)}
//         />
//       </div>

//       <button
//         className="btn btn-primary"
//         onClick={updatePayment}
//       >
//         Update Payment
//       </button>

//     </div>
//   );
// };

// export default EditLiftPayment;

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const EditLiftPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { selectedItem } = location.state;

  const [previousBal] = useState(Number(selectedItem.li_pay_pre_bal));

  const [paidAmt, setPaidAmt] = useState(Number(selectedItem.li_pay_paid_amt));

  const [paymentMode, setPaymentMode] = useState(selectedItem.li_payment_mode);

  const [remarks, setRemarks] = useState(selectedItem.li_pay_remark);

  const totalBalance = previousBal - paidAmt;

  async function updatePayment() {
    const response = await fetch(
      "https://liftapp.infysky.in/liftapp_api/api/update_lift_payment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          li_pay_id: selectedItem.li_pay_id,
          paidAmt,
          totalBalance,
          paymentMode,
          remarks,
        }),
      },
    );

    const data = await response.json();

    alert(data.message);

    navigate("/app/lift_paid_data");
  }

  return (
    <div className="container mt-5">
      <h3>Edit Lift Payment</h3>

      {/* Customer Name */}
      <div className="mb-3">
        <label>Customer Name</label>
        <input
          type="text"
          className="form-control"
          value={selectedItem.li_pay_cu_name}
          disabled
        />
      </div>

      {/* Previous Balance */}
      <div className="mb-3">
        <label>Previous Balance</label>
        <input
          type="number"
          className="form-control"
          value={previousBal}
          disabled
        />
      </div>

      {/* Paid Amount */}
      <div className="mb-3">
        <label>Paid Amount</label>
        <input
          type="number"
          className="form-control"
          value={paidAmt}
          onChange={(e) => setPaidAmt(Number(e.target.value))}
        />
      </div>

      {/* Auto Calculated Total Balance */}
      <div className="mb-3">
        <label>Total Balance</label>
        <input
          type="number"
          className="form-control"
          value={totalBalance}
          disabled
        />
      </div>

      {/* Payment Mode */}
      <div className="mb-3">
        <label>Payment Mode</label>
        <input
          type="text"
          className="form-control"
          value={paymentMode}
          onChange={(e) => setPaymentMode(e.target.value)}
        />
      </div>

      {/* Remarks */}
      <div className="mb-3">
        <label>Remarks</label>
        <textarea
          className="form-control"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </div>

      <button className="btn btn-primary" onClick={updatePayment}>
        Update Payment
      </button>
    </div>
  );
};

export default EditLiftPayment;
